<template>
  <div id="main">
    <b-navbar>
        <template slot="brand">
            <b-navbar-item tag="router-link" to="/">
                MTG Fake Finder
            </b-navbar-item>
        </template>
        <template slot="start">
        </template>

        <template slot="end">
            <b-navbar-item tag="router-link" to="/product">
                Product
            </b-navbar-item>
            <b-navbar-item tag="router-link" to="/pricing">
                Pricing
            </b-navbar-item>
            <b-navbar-item tag="router-link" to="/contact">
                Contact
            </b-navbar-item>
            <b-navbar-item v-if="!hasUser" tag="div">
                <div class="buttons">
                    <router-link class="button is-primary" to="/signin">
                        <strong>Sign up</strong>
                    </router-link>
                    <router-link class="button is-light" to="/signin">
                        Log in
                    </router-link>
                </div>
            </b-navbar-item>
            <b-navbar-item v-if="hasUser" tag="div">
                <div class="buttons">
                    <b-navbar-dropdown arrowless>
                        <b-icon slot="label" icon="user" size="is-medium" />
                        <b-navbar-item tag="router-link" to="/account">
                            Account
                        </b-navbar-item>
                        <b-navbar-item tag="router-link" to="/signout">
                            Sign Out
                        </b-navbar-item>
                    </b-navbar-dropdown>
                    <router-link class="button is-primary" to="/app">
                        <strong>App</strong>
                    </router-link>
                </div>
            </b-navbar-item>
        </template>
    </b-navbar>

    <router-view/>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'main',
  computed: {
    ...mapState('user', { hasUser: 'hasUser' }),
  }
};
</script>

<style lang="scss">
#main {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
